import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const preLogin = (tenantName, userName, isConsentRequired, isClientId) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.LOGIN.PRE_LOGIN(
      tenantName,
      userName,
      isConsentRequired,
      isClientId
    )
  );
};

export default preLogin;
